/** User navigation and deliberate aborts are control flow, not failures. */
export const isCancellation = (error: unknown): boolean => {
  if (!error || typeof error !== 'object') return false
  return (
    ('name' in error && error.name === 'AbortError') ||
    ('code' in error && error.code === 'ERR_CANCELED')
  )
}
